import Radio from 'antd/es/radio';

export default Radio;
